<div class="card card-nb h-100 w-100">
    <div class="card-body p-4 w-100">
        <h2>{{ 'subscription-trial-ai-tariff-infos_headline' | i18next }}</h2>
        <span [innerHTML]="'subscription-trial-ai-tariff-infos_note' | i18next"></span>
        <div class="d-flex flex-column">
            <div class="d-flex mt-3">
                <ul>
                    <li>{{ 'subscription-trial-ai-tariff-infos_restriction' | i18next }}</li>
                </ul>
            </div>
            <div class="mb-3">
                <i class="fa fa-info-circle red mr-2"></i>
                <span class="subinformations">{{ 'subscription-trial-ai-tariff-infos_footer' | i18next }}</span>
            </div>
        </div>
    </div>
</div>